/**
 * Update the value of a controlled input element.
 *
 * USE WITH CAUTION - direct state update is the best practice in most cases.
 *
 * This can be helpful e.g. if you need to trigger a programmatic change in a controlled input
 * that will fire a full-blown React.ChangeEvent.
 *
 * Source: https://hustle.bizongo.in/simulate-react-on-change-on-controlled-components-baa336920e04
 */
export const updateControlledInputValue = (
  input: HTMLInputElement,
  value: string,
) => {
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value',
  )?.set;
  nativeInputValueSetter?.call(input, value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
};
